<template>
  <div
    class="tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-gap-2 tw-px-2"
  >
    <span
      class="tw-text-[12px] tw-font-normal tw-break-words tw-text-justify"
      :style="`color: ${isIgnored ? '#DBDBDB' : '#211F58'}`"
    >
      {{ title }}
    </span>
    <div v-if="!isIgnored" class="tw-flex tw-h-full tw-items-center">
      <CheckboxIcon />
    </div>
  </div>
</template>

<script lang="ts" setup>
import CheckboxIcon from "@/components/svgs/checkboxIcon.vue";

defineProps<{
  title?: string;
  isIgnored?: boolean;
}>();
</script>
